import { ApiErrorResponse } from '@/api/type/commonTypes';
import { api } from '../axiosInstance';

interface putServiceDeActivateProps {
  partnerServiceId: string;
}

// 파트너 서비스 비활성화
export const putServiceDeActivate = async ({
  partnerServiceId,
}: putServiceDeActivateProps) => {
  const res = await api.put<ApiErrorResponse>(
    `/api/web/partners/partner-services/${partnerServiceId}/deactivate`
  );
  return res.data;
};
